// extracted by mini-css-extract-plugin
export default {"button":"styles_button__KNAon","smallButton":"styles_smallButton__mafhI"};